exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".primary__submitButton___FzWbS {\n  background: #50E3C2;\n  padding: 8px 12px;\n  border: 0;\n  border-bottom: 2px solid #4fd0b3;\n  border-radius: 7px;\n  color: #FFFFFF;\n  font-size: 20px;\n  outline: none;\n  cursor: pointer; }\n  .primary__submitButton___FzWbS[type=\"reset\"] {\n    background-color: #A1A4A3;\n    border-bottom: 2px solid #878b8a; }\n", ""]);

// exports
exports.locals = {
	"submitButton": "primary__submitButton___FzWbS"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules=true&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!./~/sass-loader?includePaths[]=./src/styles!./src/components/FormElements/Buttons/Primary/primary.scss
// module id = 644
// module chunks = 0